import { render } from "./QuizTimer.vue?vue&type=template&id=f9f78328"
import script from "./QuizTimer.vue?vue&type=script&lang=js"
export * from "./QuizTimer.vue?vue&type=script&lang=js"

import "./QuizTimer.vue?vue&type=style&index=0&id=f9f78328&lang=scss"
script.render = render

export default script